// import multiguard from 'vue-router-multiguard';

import Map from '@/views/public/Map.vue'
import Wall from '@/views/media/Wall.vue'

// import Guard from '@/router/middleware';

export default [
    {
        path: '/',
        name: Map,
        component: Map,
        // beforeEnter: multiguard([Guard.checkAuth]),
    },
    {
        path: '/media/wall',
        name: 'wall',
        component: Wall,
    },
    {
        path: '/media/map',
        name: 'map',
        component: Map,
    },
]
